﻿export const isDesktop = () => Boolean(document.querySelector('body.is-desktop-detected'));
export const isMobile = () => Boolean(document.querySelector('body.is-mobile-detected'));
export const isTablet = () => Boolean(document.querySelector('body.is-tablet-detected'));
export const isIOS = () => Boolean(document.querySelector('body.ios-device'));
export const isFullscreen = () => Boolean(document.querySelector('body.is-fullscreen'));
